/* istanbul ignore file */

import type { FormApi } from 'final-form';

/* istanbul ignore next */
export const createFormFieldsGetter =
    <T>(form: FormApi<T>) =>
    () =>
        form.getRegisteredFields().reduce((map: { [key: string]: string }, name: string) => {
            const fieldValue = form.getFieldState(name)?.value;
            const value = typeof fieldValue === 'string' ? fieldValue.trim() : fieldValue;

            return { ...map, [name]: value };
        }, {});

export * from './validators';
export { getValidatorFromForm } from './get-validator-from-form';
export { updateFormFields } from './update-form-fields';
export { removeCookies } from './remove-cookies';
